/**
 * Updates meshbot block fields based on configuration object
 * Creates a new block with updated field values according to the provided config
 * Pure function - does not mutate the original block
 * @param {Object} block - Meshbot block object containing fields array
 * @param {Object} config - Configuration object where keys are field names and values are new field values
 * @returns {Object} New block object with updated field values
 * @example
 * const block = {
 *   blockType: 'when',
 *   fields: [
 *     { name: 'time', type: '24_hours_time_array', value: ['10:00'] },
 *     { name: 'days', type: 'array', value: [1, 2, 3] }
 *   ]
 * };
 * const config = { time_node: ['14:00', '18:00'], days: [5, 6, 7] };
 * updateBlockFieldsByConfig(block, config)
 * // returns {
 * //   blockType: 'when',
 * //   fields: [
 * //     { name: 'time', type: '24_hours_time_array', value: ['14:00', '18:00'] },
 * //     { name: 'days', type: 'array', value: [5, 6, 7] }
 * //   ]
 * // }
 *
 * @example
 * const block = { fields: [{ name: 'status', value: false }] };
 * updateBlockFieldsByConfig(block, { status: true })
 * // returns { fields: [{ name: 'status', value: true }] }
 */
export const updateBlockFieldsByConfig = (block, config) => {
    const updatedBlock = { ...block };
    updatedBlock.fields = [...block.fields];
    const fieldsNames = Object.keys(config);
    updatedBlock.fields.forEach((field, index) => {
        if (fieldsNames.includes(field.name)) {
            updatedBlock.fields[index] = { ...field, value: config[field.name] };
        }
    });

    return updatedBlock;
};
